/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./AppLoader.vue?vue&type=template&id=1c9798b4&scoped=true"
import script from "./AppLoader.ts?vue&type=script&lang=ts&external"
export * from "./AppLoader.ts?vue&type=script&lang=ts&external"
import style0 from "./AppLoader.vue?vue&type=style&index=0&id=1c9798b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9798b4",
  null
  
)

export default component.exports